/* global window appData */

import Vue from 'vue';
import $ from 'jquery';
import { mapState } from 'vuex';
import { createPopper } from '@popperjs/core';


// Mixins
import { RestComponent } from '../../../mixins/rest-component';
import { CaseListing } from '../../../mixins/case-listing';

// Template and media files
import template from '../shared-template/page-listing-overview.vhtml';
import logo from '../../../../_img/logo-esbjerghavn.svg';
import arrowBtn from '../../../../_img/icons/arrow-btn.svg';
import Userbar from '../../userbar/userbar'


export const PageUserListingOverview = Vue.component('page-user-listing-overview', {
	components: {
		logo,
		arrowBtn,
		Userbar
	},
	mixins: [RestComponent, CaseListing],
	template: template,
	props: {
		appLoaded: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		containerWidth: 0,
		hideMoreThan300: false,
		hideMoreThan500: false,
		hideLogo: false,
		mailingList: true,
		userCreate: true,
		showValueChains: true,
		isLoggedIn: appData.user.isLoggedIn,
		valuechain: '',
		options: [
			{
				value: "deadline",
				label: "Sort by deadline"
			},
			{
				value: "title",
				label: "Sort by name"
			},
			{
				value: "created",
				label: "Sort by created"
			}
		],
		valuechains: [
			{
				value: "",
				label: "See workflows"
			},
			{
				value: "cargo",
				label: "Cargo operations"
			},
			{
				value: "fisheries",
				label: "Fisheries"
			},
			{
				value: "offshore",
				label: "Offshore wind"
			},
			{
				value: "oil",
				label: "Oil and gas"
			},
			{
				value: "port",
				label: "Port services"
			},
			{
				value: "vessel",
				label: "Vessel services"
			}
		]
	}),
	computed: {
		website: vm => vm.$store.state.appsData.data.website,
		...mapState({
			website: state => state.appsData.data.website,
			showLogo: state => state.content.showLogo,
			isNavigating: state => state.pages.isNavigating,
		}),
		showeula: function () {
			return false;
		},
		reduce: function () {
			return label => label.value
		}
	},
	watch: {
		content() {
			this.$store.commit('sidebar/updateData', {
				name: 'parent',
				value: this.content.parent,
			});
		},
		selectedCategory(newValue, oldValue) {
			const url = new URL(document.location.href);
			const params = new URLSearchParams(url.selected);

			params.set('selected', newValue);

			if (newValue.length === 0 || newValue === null) {
				params.delete('selected');
			}

			this.$router.replace({ query: { 'selected': newValue.join(',') } });
		}
	},
	created() {
		this.$store.dispatch('pages/setScrollPosition');
		this.$store.dispatch('pagination/makeFullScreen');
		this.$store.commit('pagination/updateData', {
			name: 'outOfViewPos',
			value: '',
		});
		this.$store.commit('pagination/updateData', {
			name: 'fullWidthUntilLg',
			value: true,
		});
		this.$store.commit('pagination/updateData', {
			name: 'fullWidthUntilLg',
			value: true,
		});
	},
	mounted() {
		const urlParams = new URLSearchParams(window.location.search);
		const selected = urlParams.get('selected');

		if (selected) {
			this.selectedCategory = selected.split(',');
		}
	},
	beforeDestroy() {
	},
	methods: {
		toogleScrollElements(e) {
			e.target.scrollTop > 50 ? this.hideLogo = true : this.hideLogo = false;
		},
		navigateToIndex(link) {
			window.removeEventListener('scroll', this.$options.throttleFunction);
			this.$store.commit('sidebar/updateData', {
				name: 'transparentUntilLg',
				value: false,
			});
			this.$store.commit('sidebar/updateData', {
				name: 'stuckToTopMobile',
				value: false,
			});

			this.navigateLeft(link);
			setTimeout(() => {
				this.$store.commit('sidebar/updateData', {
					name: 'sidebarPos',
					value: 'left',
				});
			}, 100);
		},
		withPopper (dropdownList, component, {width}) {
			/**
			* We need to explicitly define the dropdown width since
			* it is usually inherited from the parent with CSS.
			*/
			dropdownList.style.width = width;

			/**
			* Here we position the dropdownList relative to the $refs.toggle Element.
			*
			* The 'offset' modifier aligns the dropdown so that the $refs.toggle and
			* the dropdownList overlap by 1 pixel.
			*
			* The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
			* wrapper so that we can set some styles for when the dropdown is placed
			* above.
			*/
			const popper = createPopper(component.$refs.toggle, dropdownList, {
				placement: 'bottom',
				modifiers: [
				{
					name: 'offset', options: {
					offset: [0, -1]
					}
				},
				{
					name: 'toggleClass',
					enabled: true,
					phase: 'write',
					fn ({state}) {
					component.$el.classList.toggle('drop-up')
					},
				}]
			});

			/**
			* To prevent memory leaks Popper needs to be destroyed.
			* If you return function, it will be called just before dropdown is removed from DOM.
			*/
			return () => popper.destroy();
		}
	}
});



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-user-listing-overview/page-user-listing-overview.js